<template>
	<div>
		<v-text-field v-model="name" label="Name" :disabled="!editable"></v-text-field>
		<v-textarea v-model="description" label="Beschreibung" :disabled="!editable"></v-textarea>	
		<v-autocomplete v-if="doc.id" :disabled="!editable" append-icon="mdi-plus-circle" color="accent" @click:append="user_dialog = true" v-model="members" :items="users" multiple chips item-text="display_name" item-value="id" label="Mitarbeiter">
		<template v-slot:selection="data">
			<v-dialog width="400px">
				<template v-slot:activator="{ on}">
					<v-chip color="accent" close v-on="on" @click:close="removeMember(data.item)">
						<v-avatar left>
							<v-img  v-if="data.item.profile_image" :src="data.item.profile_image"></v-img>
							<v-icon color="white" v-else>mdi-account-circle</v-icon>
						</v-avatar>
						{{ data.item.display_name }}
					</v-chip>
				</template>
				<DisplayUser :user="data.item"></DisplayUser>
			</v-dialog>
		</template>
		</v-autocomplete>			
		<v-dialog v-model="user_dialog" width="400px">
			<v-card>
				<DialogTitle title="Neuen Kontakt Anlegen" @close="user_dialog = false"></DialogTitle>
				<v-card-text>
					<p>Some information about what you're doing here </p>
					<UserForm :doc="new_user_object"
					@change="(u) => new_user_object = u"></UserForm>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn fab small color="primary2" @click="addUser"> 
						<v-icon color="white">mdi-arrow-right-bold</v-icon>
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		</div>
</template>

<style lang="less">
	
</style>

<script type="text/javascript">
	import Vuex from "vuex";
	import DialogTitle from "@/components/elements/DialogTitle"
	import UserForm from "@/components/forms/UserForm"
	import DisplayUser from "@/components/assessment/users/DisplayUser"

	export default {
		name: "GroupForm", 
		props: {
			doc: {type: Object}
		},
		data: () => {
			return {
				id: null,
				assessment: null,
				members: 0, 
				name: '',
				description: '', 
				user_dialog: false,
				new_user_object:  {
					first_name: '',
					last_name: '', 
					email: '',
				}
			}
		
		}, 
		components: {
			DialogTitle,
			UserForm,
			DisplayUser,
		},
		computed: {
			...Vuex.mapState({
				user: state => state.user,
				users: state => state.users,
				organisations: state => state.organisations,
				assessments: state => state.assessments,
			}),
			assessment_details(){
				var assessment = this.assessment;
				if( !assessment ){
					return;
				}
				return this.assessments.find( a => a.id == assessment )
			},
			organisation(){
				return this.assessment_details.organisation;
			},
			editable(){
				return this.assessment_details.lead == this.user.id;
			}, 
			updatedDoc(){
				return {
					name: this.name, 
					description: this.description
				}
			}
		},
		watch: {
			updatedDoc() {
				this.$emit("change", this.updatedDoc)
			}, 
			doc: {
				immediate: true, 
				deep: true,
				handler(){				
					if( this.doc ){				
						for( var key in this.$data ){
							if( typeof this.doc[key] !== 'undefined'){
								this[key] = this.doc[key]
							}
						}
					}
				}
			}, 
			members(nv, ov){
				nv.forEach( v => {
					if( ov.indexOf(v) < 0 ){
						this.$store.dispatch("groups/addMember", {group_id: this.id, user_id: v } )
					}
				} )
				ov.forEach( v => {
					if( nv.indexOf(v) < 0 ){
						this.$store.dispatch( "groups/removeMember", {group_id: this.id, user_id: v } )
					}
				} )
			}
		},
		methods: {
			addMember(id){
				if( this.members.indexOf( id ) < 0 ){
					this.members.push( id );
				}
			},
			addUser(){
				var user = this.new_user_object;
				user.id = this.generateId();
				user.organisation = [this.organisation];
				this.$store.dispatch( "users/addUser", user );
				this.user_dialog = false;
				this.addMember(user.id)
			}, 
			removeMember(user){
				this.members = this.members.filter( m => m !== user.id );
			}
		}
		// created(){
			
		// }

	}
</script> 